import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import NewConvoHeader from 'components/App/DesktopView/shared/NewConvoHeader'
import ReplyEmailForm from 'components/App/DesktopView/CommunicationForms/Reply/Email'
import Scroller from 'components/Scroller'
import ImageLightbox from 'components/ImageLightbox'
import { doUpsertReplyDraft } from 'ducks/drafts2/operations/doUpsertReplyDraft'
import {
  selectDraftIdByTicketId,
  selectMailboxIdForDraftById,
} from 'ducks/drafts2/selectors'
import { doFetchCurrentContact } from 'ducks/crm/contacts/operations/fetching/doFetchCurrentContact'
import { selectCurrentUserId } from 'ducks/currentUser/selectors'
import useQueryParamToRecipientLoader from 'util/hooks/useQueryParamToRecipientLoader'
import { selectReassignTicketOnReply } from 'selectors/tickets/assignment'
import { styles } from '../shared/styles'

export default function NewEmailPage() {
  const dispatch = useDispatch()
  const currentUserId = useSelector(selectCurrentUserId)
  const fetchingTo = useQueryParamToRecipientLoader()

  const draftId = useSelector(state =>
    selectDraftIdByTicketId(state, 'new', 'reply')
  )
  const currentMailboxId = useSelector(state =>
    selectMailboxIdForDraftById(state, draftId)
  )

  const reassignTicketOnReply = useSelector(selectReassignTicketOnReply)

  useEffect(
    () => {
      dispatch(
        doUpsertReplyDraft(draftId, 'reply', 'new', null, {
          mailboxId: currentMailboxId,
          assigneeId: reassignTicketOnReply ? currentUserId : null,
        })
      )
    },
    [dispatch, draftId, currentMailboxId, currentUserId, reassignTicketOnReply]
  )

  useEffect(
    () => {
      dispatch(doFetchCurrentContact())
    },
    [dispatch, draftId]
  )

  if (fetchingTo) return null

  return (
    <React.Fragment>
      <NewConvoHeader isLogging={false} />
      <div css={styles.composeFormContainer}>
        <Scroller>
          <ReplyEmailForm ticketId="new" />
        </Scroller>
      </div>
      <ImageLightbox />
    </React.Fragment>
  )
}
